<template>
  <div
    v-if="list.length"
    class="around-breadcrumbs"
  >
    <PageWrap>
      <UiBreadcrumbs
        :list="list"
        :events-identifier="MF_NAME"
      />
    </PageWrap>
  </div>
</template>

<script setup lang="ts">
  import { UiBreadcrumbs, type IUiBreadcrumbItem } from '@experience/core-breadcrumbs-ui';

  import { MF_NAME } from '@/shared/config/env';
  import PageWrap from '@/shared/ui/PageWrap.vue';

  defineProps<{
    list: IUiBreadcrumbItem[];
  }>();
</script>

<style scoped lang="scss">
  .around-breadcrumbs {
    margin-bottom: 8px;

    @include tablet {
      margin-bottom: 4px;
    }
  }
</style>
